var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogsGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.04102 0 0 .04102 .5 .5)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    d: "M160 160h192v32H160z",
    transform: "translate(5.775 5.775)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    d: "M160 256h192v32H160z",
    transform: "translate(5.775 9.24)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    d: "M160 352h96v32h-96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.999 32h-68.578C320.875 13.035 292.107 0 256 0c-36.107 0-64.875 13.035-75.422 32h-68.577C85.532 32 64 53.531 64 80v384.001c0 26.469 21.532 48 48.001 48h288c26.469 0 48-21.531 48-48V80c-.001-26.469-21.533-48-48.002-48ZM256 32c8.836 0 16 7.162 16 16 0 8.836-7.164 16-16 16s-16-7.164-16-16c0-8.838 7.164-16 16-16Zm160 432c0 8.827-7.172 16-16.001 16H112.001C103.173 480 96 472.829 96 464V80c0-8.827 7.172-16 16.001-16h64v16c0 8.844 7.156 16 16 16H320c8.844 0 16-7.156 16-16V64h64.001c8.827 0 16 7.172 16 16v384H416Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsGrey);
export default __webpack_public_path__ + "static/media/logs-grey.c32fdc8bc90c54e51b28bb0b04457dea.svg";
export { ForwardRef as ReactComponent };